// extracted by mini-css-extract-plugin
module.exports = {"statusCircle":"styles_statusCircle__2yRBL"};